import { IsOptional, IsArray, ValidateNested } from "class-validator";
import { Type } from "class-transformer";

import { IAdapterWorkordersReleaseAction } from "./adapter-workorders-release-action.interface";
import { QueryDto } from "../query";

export class AdapterWorkordersReleaseActionDto
  implements IAdapterWorkordersReleaseAction
{
  @IsOptional()
  @IsArray()
  entity_ids?: string[];

  @IsOptional()
  @ValidateNested()
  @Type(() => QueryDto)
  query?: QueryDto;
}
